/* Custom claim UI; installed Shopify discount function enforces free pricing. */
(() => {
  if (window.stCartGiftsLoaded) return;
  window.stCartGiftsLoaded = true;
  const base = window.Shopify?.routes?.root || '/';
  const code = 'Salepify promotion - 20260119_154853 - Free Gift';
  const property = '_salepify-progress-bar';
  const gifts = [
    {key:'pen',id:52764978315571,handle:'untitled-dec1_11-26',threshold:10000,marker:'5807-0'},
    {key:'hat',id:52978064752947,handle:'staten-tools-hydro-sport-work-snap-back',threshold:50000,marker:'5807-1'}
  ];
  const nativeFetch = window.fetch.bind(window);
  let busy = false, syncing = null, lastCart = null, timer, products;
  const roots = () => [...document.querySelectorAll('[data-st-cart-gifts]')];
  const isGift = item => gifts.some(g => item.variant_id === g.id && item.properties?.[property] === g.marker);
  const spend = cart => cart.items.reduce((sum,item) => sum + (gifts.some(g => g.id === item.variant_id) ? 0 : item.original_line_price), 0);
  const money = cents => new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(cents/100);
  function error(text) {
    roots().forEach(root => {const el=root.querySelector('[data-gift-error]'); el.textContent=text; el.hidden=!text;});
  }
  async function request(path, data) {
    const r = await nativeFetch(base+path, data ? {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(data)} : {cache:'no-store',headers:{Accept:'application/json'}});
    const result = await r.json();
    if (!r.ok || result.status) throw Error(result.description || 'Unable to update gifts. Please try again.');
    return result;
  }
  function render(cart) {
    lastCart = cart;
    const amount=spend(cart);
    roots().forEach(root => gifts.forEach(g => {
      const card=root.querySelector(`[data-gift-card="${g.key}"]`);
      const claimed=cart.items.some(i => i.variant_id===g.id && isGift(i));
      const available=products?.[g.key] === true;
      const eligible=cart.currency==='USD' && amount>=g.threshold;
      const button=card.querySelector('[data-gift-claim]');
      const text=claimed?'Gift claimed':!products?'Checking stock…':!available?'Temporarily unavailable':!eligible?'Not unlocked yet':'Claim free '+g.key;
      if(button.textContent!==text) button.textContent=text;
      button.disabled=busy || claimed || !eligible || !available;
      const status=claimed?'Added to your cart.':cart.currency!=='USD'?'Gift claims are available in USD.':!available&&products?'This gift is out of stock.':eligible?'Your free gift is unlocked.':`${money(g.threshold-amount)} away from your free ${g.key}.`;
      const el=card.querySelector('[data-gift-status]');
      if(el.textContent!==status) el.textContent=status;
      card.querySelector('[data-gift-progress]').value=Math.min(100,amount/g.threshold*100);
    }));
  }
  async function reconcile() {
    let cart=await request('cart.js');
    const amount=spend(cart), updates={}, seen=new Set();
    cart.items.forEach(item => {
      if(!isGift(item)) return;
      const g=gifts.find(g=>g.id===item.variant_id);
      if(cart.currency!=='USD'||amount<g.threshold||seen.has(g.key)) updates[item.key]=0;
      else {seen.add(g.key); if(item.quantity!==1) updates[item.key]=1;}
    });
    let changed=Object.keys(updates).length>0;
    if(changed) cart=await request('cart/update.js',{updates});
    if(cart.items.some(isGift) && !cart.discount_codes?.some(d=>d.code===code && d.applicable)) {
      const codes=[...new Set([...(cart.discount_codes||[]).map(d=>d.code),code])];
      cart=await request('cart/update.js',{discount:codes.join(',')});
      changed=true;
    }
    // Never quietly charge for a claimed gift if a discount stops applying.
    const unpaid=cart.items.filter(i=>isGift(i)&&i.final_line_price!==0);
    if(unpaid.length) {
      cart=await request('cart/update.js',{updates:Object.fromEntries(unpaid.map(i=>[i.key,0]))});
      changed=true;
      error('The free-gift discount could not be applied. The gift was removed so you will not be charged. Please try claiming again.');
    }
    render(cart);
    if(changed && /\/cart\/?$/.test(location.pathname)) location.reload();
    return {cart,changed};
  }
  function sync() {
    if(busy) return Promise.resolve({cart:lastCart,changed:false});
    if(!syncing) syncing=reconcile().catch(e=>{error(e.message);throw e;}).finally(()=>{syncing=null;});
    return syncing;
  }
  function schedule() {
    clearTimeout(timer);
    timer=setTimeout(()=>sync().catch(()=>{}),500);
  }
  // Observe the theme's fetch and jQuery/XHR cart writes without replacing handlers.
  window.fetch = async (...args) => {
    const result=await nativeFetch(...args);
    const url=String(args[0]?.url || args[0]);
    if(/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url)) schedule();
    return result;
  };
  const open=XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open=function(method,url,...rest) {
    if(/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(String(url))) this.addEventListener('loadend',schedule,{once:true});
    return open.call(this,method,url,...rest);
  };
  document.addEventListener('click',async event=>{
    const button=event.target.closest('[data-gift-claim]');
    if(!button||busy||button.disabled) return;
    event.preventDefault(); busy=true; error('');
    if(lastCart) render(lastCart);
    try {
      if(syncing) await syncing;
      const cart=await request('cart.js'), gift=gifts.find(g=>g.key===button.dataset.giftClaim);
      if(cart.currency!=='USD'||spend(cart)<gift.threshold) throw Error('Your cart no longer qualifies for this gift.');
      if(!cart.items.some(i=>i.variant_id===gift.id&&isGift(i))) {
        await request('cart/add.js',{items:[{id:gift.id,quantity:1,properties:{[property]:gift.marker,'Gift':'Complimentary cart reward'}}]});
      }
      busy=false;
      const result=await sync();
      if(!result.cart.items.some(i=>i.variant_id===gift.id&&isGift(i)&&i.final_line_price===0)) {
        throw Error('The gift could not be confirmed as free and was removed. Please try again.');
      }
      // Render server totals and lines, not optimistic free prices.
      location.assign(base+'cart');
    } catch(e) {error(e.message);}
    finally {busy=false;if(lastCart)render(lastCart);}
  });
  window.stCartGiftsValidate = async () => {
    if(busy) throw Error('Please wait for your gift claim to finish.');
    const result=await sync();
    if(result.changed) throw Error('Your gifts were updated. Please review your cart before checkout.');
  };
  let observerPending=false;
  new MutationObserver(()=>{
    if(observerPending) return;
    observerPending=true;
    requestAnimationFrame(()=>{observerPending=false;if(lastCart)render(lastCart);});
  }).observe(document.body,{childList:true,subtree:true});
  Promise.all(gifts.map(async g=>{
    const product=await request(`products/${g.handle}.js`);
    return [g.key,product.variants.some(v=>v.id===g.id&&v.available)];
  })).then(entries=>{products=Object.fromEntries(entries);schedule();}).catch(()=>error('Gift availability could not be checked. Please refresh to try again.'));
  window.addEventListener('focus',schedule);
  schedule();
})();